<template>
	<div>
		<div class="row">
			<div class="col-md-6">
				<div class="input-group">
					<input
						type="text"
						:placeholder="$t('search-ellipses')"
						v-model="search.q"
						class="form-control form-control-lg"
						@keyup.enter="newSearch"
					/>
					<div class="input-group-append">
						<button class="btn btn-primary" type="button" @click="newSearch">
							<b-icon icon="search"></b-icon>
						</button>
					</div>
				</div>
			</div>
			<div class="col-md-3">
				<SelectInput
					v-model="datasource"
					:options="datasourceOptions"
					:indexIsValue="true"
					:labelCb="option => $t(option)"
					:label="$t('data-source')"
					:srOnly="true"
					:nullable="true"
					:nullLabel="$t('data-source')"
					size="lg"
					@input="datasourceChanged"
					class="mt-3 mt-md-0"
				/>
			</div>
			<div class="col-md-3">
				<router-link class="btn btn-primary btn-block btn-lg mt-3 mt-md-0 mb-3" to="/settings/reports/dataelements/edit">{{ $t('new-item') }}</router-link>
			</div>
		</div>

		<InfiniteScroll
			scrollElementId="main"
			type="ReportDataElement"
			:dataUrl="`${$settings.APIBaseURL}/reporting/dataelements/list`"
			dataProperty="dataelements"
			class="list-group border-radius-2 no-border"
			itemClass="list-group-item"
			@selectItem="selectItem"
			ref="infinitescroll"
			idProperty="formtype_id"
		/>
	</div>
</template>

<script>
import InfiniteScroll from "src/components/InfiniteScroll";
import datasources from "src/include/datasources";

export default {
	components: {
		InfiniteScroll
	},
	data() {
		return {
			search: {
				q: ""
			},
			datasource: null
		};
	},
	mounted() {
		this.getItems();
	},
	methods: {
		newSearch() {
			this.getItems();
		},
		datasourceChanged(value) {
			this.datasource = value;
			this.getItems();
		},
		getItems() {
			const body = {
				q: this.search.q ? this.search.q : "",
				datasource: this.datasource ? this.datasource : ""
			};
			this.$refs.infinitescroll.getData("replace", body);
		},
		selectItem(item) {
			this.$store.commit("showBlockingSpinner");
			this.$router.push(`/settings/reports/dataelements/edit/${item.id}`);
		}
	},
	computed: {
		datasourceOptions() {
			const options = {};
			for (const key in datasources) {
				if (key === "none" || key === "other") {
					continue;
				}
				options[key] = datasources[key];
			}
			return options;
		}
	}
};
</script>
